import React, { useEffect, useState } from 'react';
import { composeItemDefs } from './composeItemDefs';

import NoResults from '@molecules/NoResults/NoResults';
import NoSaved from '@molecules/NoSaved/NoSaved';
import SearchResultCardList from '../SearchResultsList/SearchResultList';

import { useSearchResults } from '@context/DataContext';

const SearchResults = ({ collection }) => {
  const { resultTab } = useSearchResults();
  const [emptyNotice, setEmptyNotice] = useState();

  useEffect(() => {
    setEmptyNotice(resultTab);
  }, [resultTab]);

  const EmptyList = () => {
    return emptyNotice === 'saved' ? <NoSaved /> : <NoResults />;
  };

  const itemDefs = composeItemDefs(collection);
  return (
    <>
      <SearchResultCardList itemDefs={itemDefs} />
      {EmptyList()}
    </>
  );
};

export default SearchResults;
